<template>
    <CCard class="order-fd-card" v-show="haveAnalyticsData">
        <CCardHeader>
            <strong>Данные для аналитики</strong>
        </CCardHeader>
        <CCardBody>
            <CForm>
                <template v-for="item in analyticsData">
                    <CRow :key="`analyticsData-${item.id}`" form class="form-group">
                        <CCol style="display: flex; align-items: center;">
                            <input v-model="order.analytics_data" :value="item.title" type="checkbox" />
                            <span class="ml-2">{{ item.title }}</span>
                        </CCol>
                    </CRow>
                </template>
                <CRow form class="form-group">
                    <CCol style="display: flex; align-items: center;">
                        <input v-model="other.enabled" type="checkbox" />
                        <span class="ml-2">Другое поручение</span>
                    </CCol>
                </CRow>
                <CRow form class="form-group" v-if="other.enabled">
                    <CInput
                        v-model="other.data"
                        placeholder="Опишите поручение"
                    />
                </CRow>
            </CForm>
        </CCardBody>
        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="update"
            >Сохранить</CButton
            >
        </CCardFooter>
    </CCard>
</template>

<script>
    export default {
        name: 'OrderAnalyticsData',

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                haveAnalyticsData: false,
                analyticsData: [],
                other: {
                    enabled: false,
                    data: ''
                }
            };
        },

        computed: {
            adminOnly() {
                return JSON.parse(localStorage.getItem('settings'))?.is_business_admin;
            },
        },

        watch: {
            order: async function(val) {
                if(this.order.ed && this.order.ed.items[0].entity && this.order.ed.items[0].entity.entityType && this.order.ed.items[0].entity.entityType.analytics_data) {
                    this.haveAnalyticsData = true;
                    this.analyticsData = this.order.ed.items[0].entity.entityType.analytics_data_values;
                    if(!this.order.analytics_data) {
                        this.order.analytics_data = [];
                    } else {
                        const analyticsDataValues = this.analyticsData.map(item => item.title);
                        for (let index = 0; index < this.order.analytics_data.length; index ++) {
                            const item = this.order.analytics_data[index];
                            if(analyticsDataValues.indexOf(item) < 0) {
                                this.other.enabled = true;
                                this.other.data = item;
                                this.order.analytics_data.splice(index, 1);
                                return;
                            }
                        }
                    }
                }
            }
        },

        async mounted() {
        },

        methods: {
            update() {
                this.order.baseInfoOnly = true;
                if (this.other.enabled) {
                    this.order.analytics_data.push(this.other.data);
                }
                this.$emit('update', this.order);
            }
        },
    };
</script>

<style lang="scss">
.input_field {
    outline: none;
}
.component-cart__promocode {
    z-index: 99;

    &__input {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border: 1px solid #d8dbe0;
        z-index: 99;
        padding: 10px;

        > input:focus-within {
            // border: 1px solid #90949A;
        }
        > input.input-focused {
            border: none;
        }

        &.input.input-focused {
            // border: 1px solid #90949A;
        }
        &.input.input-success {
            border: 1px solid #219653;
        }
        &.input.input-with-errors {
            border: 1px solid #EB5757;
        }
    }
    &__button {
        text-align: right;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #219653;

        &:disabled {
            color: #C3C8CC;
            opacity: 1;
        }

        &__true {
            color: #738FA1;
            width: auto;
            // width: 16px;
            // height: 16px;
            // background: url('../../static/cart_promocode-true.svg') center center no-repeat;
        }
        &__false {
            width: 16px;
            height: 16px;
        }
    }
    &__description {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #219653;
    }
    &__error {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #EB5757;
    }
}
</style>
